// extracted by mini-css-extract-plugin
export default {"disabled":"clickable-icon__disabled__kqpLj"};